<div class="w-full max-w-[800px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #dcfce7; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">check_circle</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Aprobar Referencia</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">Confirmar aprobaci&oacute;n de carga VES</p>
    </div>
  </div>

  <!-- Info card -->
  <div style="margin: 16px 24px; padding: 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Usuario ID</span>
        <span style="color: #2563eb; font-weight: 700; font-size: 0.9rem; font-family: monospace;">#{{ referencia.userId }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Referencia</span>
        <span style="color: #111827; font-weight: 700; font-size: 0.9rem; font-family: monospace;">{{ referencia.referencia }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Titular</span>
        <span style="color: #111827; font-weight: 600; font-size: 0.9rem;">{{ referencia.titular }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ referencia.banco }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Tipo de Cuenta</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ referencia.tipoCuenta }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">N&uacute;mero de Cuenta</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">{{ referencia.cuenta }}</span>
      </div>

      <!-- Monto -->
      <div style="grid-column: 1 / -1; padding-top: 4px; border-top: 1px solid #bbf7d0;">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto</span>
        <span style="color: #16a34a; font-weight: 700; font-size: 1.1rem;">{{ formatVES(referencia.monto) }}</span>
      </div>
    </div>
  </div>

  <!-- Cuenta de trabajo asociada -->
  <div *ngIf="cuentaTrabajoMatch" style="margin: 0 24px 16px; padding: 14px 16px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px;">
    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #2563eb;">account_balance_wallet</mat-icon>
      <span style="font-weight: 700; font-size: 0.85rem; color: #1e40af;">Cuenta de trabajo asociada (Abono autom&aacute;tico)</span>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2" style="font-size: 0.82rem;">
      <div>
        <span style="color: #6b7280; font-size: 0.72rem;">Titular</span>
        <div style="font-weight: 600; color: #374151;">{{ cuentaTrabajoMatch.nombre }} {{ cuentaTrabajoMatch.apellidos }}</div>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.72rem;">Banco</span>
        <div style="font-weight: 600; color: #374151;">{{ cuentaTrabajoMatch.banco?.nombre }}</div>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.72rem;">N&uacute;mero de cuenta</span>
        <div style="font-weight: 600; color: #374151; font-family: monospace;">{{ cuentaTrabajoMatch.numeroCuenta }}</div>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.72rem;">ID cuenta trabajo</span>
        <div style="font-weight: 700; color: #2563eb; font-family: monospace;">#{{ cuentaTrabajoMatch.cuenta_trabajo_id }}</div>
      </div>
    </div>
  </div>

  <!-- Advertencia: sin cuenta de trabajo -->
  <div *ngIf="!cuentaTrabajoMatch"
    style="margin: 0 24px 16px; padding: 14px 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; display: flex; align-items: flex-start; gap: 10px;">
    <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #dc2626; flex-shrink: 0; margin-top: 1px;">error</mat-icon>
    <div>
      <p style="margin: 0 0 4px; font-weight: 700; font-size: 0.85rem; color: #dc2626;">No se encontr&oacute; cuenta de trabajo asociada</p>
      <p style="margin: 0; font-size: 0.8rem; color: #991b1b;">
        No existe una cuenta de trabajo VE activa con el n&uacute;mero de cuenta <strong style="font-family: monospace;">{{ referencia.cuenta }}</strong>.
        No se podr&aacute; registrar el abono autom&aacute;tico.
      </p>
    </div>
  </div>

  <!-- Buttons -->
  <div style="display: flex; gap: 12px; padding: 20px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end;">
    <button (click)="close()"
      style="padding: 10px 24px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;">
      Cancelar
    </button>
    <button (click)="approve()" [disabled]="loading || !cuentaTrabajoMatch"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;"
      [style.opacity]="(loading || !cuentaTrabajoMatch) ? '0.5' : '1'"
      [style.cursor]="(loading || !cuentaTrabajoMatch) ? 'not-allowed' : 'pointer'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">check</mat-icon>
      Aprobar referencia
    </button>
  </div>

</div>
